import { Component, OnInit } from '@angular/core';
import { ThemeSettingsService } from './pages/settings/service/theme-setting.service';
import { AuthService } from './shared/services/auth/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private readonly themeService: ThemeSettingsService,
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {
  }

  ngOnInit(): void {
    this.authService.isLoggedIn().then(isLoggedIn => {
      if (isLoggedIn) {
        this.themeService.setUserThemeSettings();
      }
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const storage = this.themeService.loadSettingsFromStorage();
        this.themeService.setToBody(storage);
      });
  }

}
